import { DefaultPresenter } from './default-presenter';

const prefix = 'clinica/dose_maxima';
const entity = 'Dose máxima';

export const DoseMaximaPresenter = {
	...DefaultPresenter({ prefix, entity })
};
